import React, { FC } from 'react';
import { ExtendedRunStatus, IConversationRun } from '../model/ConversationRun';
import { useConversationRun } from './hooks/useConversationRun';
import { useResourceFactory } from './hooks/useResourceFactory';
import { AssistantResponse } from './AssistantResponse';
import { ChatBubble } from 'features/pi/view/uiManager/text-instances/chat-bubble/chat-bubble';
import styles from './conversation-message.module.scss';
import { ChatLoader } from './ChatLoader';
import { ErrorMsg } from 'features/pi/view/uiManager/error-msg/error-msg';

export interface ConversationRunProps {
    run: IConversationRun;
    isLastRun: boolean;
    repostLastUserMessage: () => void;
}

export const ConversationRun: FC<ConversationRunProps> = (props) => {
    const { run, isLastRun } = props;
    const { input, containers, status, resources } = useConversationRun(run);
    const resourceFactory = useResourceFactory();

    let responseComponent = null;

    if (status === ExtendedRunStatus.FAILED || status === ExtendedRunStatus.CLIENT_ERROR) {
        responseComponent = (
            <ErrorMsg onClick={isLastRun ? props.repostLastUserMessage : undefined} />
        );
    } else if (
        status === ExtendedRunStatus.PENDING ||
        (status === ExtendedRunStatus.RUNNING && containers.length === 0)
    ) {
        responseComponent = <ChatLoader />;
    } else {
        responseComponent = <AssistantResponse run={run} isLastRun={isLastRun} />;
    }

    return (
        <div data-testid="conversation-run" className={styles.container}>
            <span className={styles.userInput}>
                {input.length > 0 && (
                    <ChatBubble text={input} additionalContainerClassName={styles.chatBubble} />
                )}
                {resources && resources.length > 0 && (
                    <div className={styles.resourcesContainer}>
                        {resources.map((resource, index) => {
                            const render = resource.selectFromFactory(resourceFactory);
                            const resourceElement = render.render(resource.data.get());
                            return resourceElement.content;
                        })}
                    </div>
                )}
            </span>
            {responseComponent}
        </div>
    );
};
